import React, { useState, useCallback, useContext } from "react";
import Template from "./ChangePassword.jsx";
import { post } from "../../util/fetch.js";
import { Context } from "../login/LoginController.jsx";

const ChangePasswordController = (props) => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const { login } = useContext(Context);

  const onChange = useCallback((e) => {
    const { value, name } = e.target;

    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      message: undefined,
      [name]: undefined,
    }));
  }, []);

  const submit = useCallback(() => {
    const { onSuccess, onError, slim } = props;
    const url = slim ? "/api/password-reset" : "/api/password-change";

    setLoading(true);

    post(url, { body: data })
      .then(() => {
        login({
          username: data.username,
          password: data.password,
        })
          .then(() => {
            setLoading(false);
            onSuccess && onSuccess();
          })
          .catch((loginErr) => {
            setLoading(false);
            setErrors(loginErr.data || {});
            onError && onError();
          });
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.data || {});
        onError && onError();
      });
  }, [data, login, props]);

  const handlers = {
    onChange,
    onButtonClick: submit,
  };

  return (
    <Template
      {...props}
      data={data}
      errors={errors}
      loading={loading}
      {...handlers}
    />
  );
};

export default ChangePasswordController;
